import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_title, { style: {"padding-right":"0"} }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createElementVNode("p", null, "Jobs", -1)
                  ])),
                  _: 1,
                  __: [1]
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_ion_spinner)
            ]))
          : (_openBlock(), _createBlock(_component_ion_list, { key: 1 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employerJobs, (job) => {
                  return (_openBlock(), _createBlock(_component_ion_card, {
                    lines: "full",
                    key: job.id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_content, null, {
                        default: _withCtx(() => [
                          _createElementVNode("h2", null, _toDisplayString(job.position), 1),
                          _createElementVNode("p", null, [
                            _createTextVNode(_toDisplayString(job.employerName) + " ", 1),
                            (job.employerWebsite)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: job.employerWebsite,
                                  target: "_blank"
                                }, " (" + _toDisplayString(job.employerWebsite?.replace(/^https?:\/\//, '').replace(/^www./, '')) + ") ", 9, _hoisted_2))
                              : _createCommentVNode("", true)
                          ]),
                          (job.postDate)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Posted on " + _toDisplayString(job.postDate), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_button, {
                        size: "small",
                        expand: "block",
                        color: "success",
                        onClick: ($event: any) => (_ctx.updateUserJobReaction(job, 'like')),
                        disabled: _ctx.isAppliedJob(job.id)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.isAppliedJob(job.id) ? 'Applied' : 'Apply'), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "disabled"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }))
      ]),
      _: 1
    })
  ], 64))
}